import { motion } from "framer-motion";

// Masked line-by-line reveal. Pass an array of strings (lines).
export const RevealText = ({
  lines = [],
  className = "",
  lineClassName = "",
  delay = 0,
  stagger = 0.12,
  as = "h1",
  duration = 0.9,
}) => {
  const Tag = motion[as] || motion.h1;
  return (
    <Tag
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.4 }}
      aria-label={lines.join(" ")}
    >
      {lines.map((line, i) => (
        <span key={i} className="reveal-line" aria-hidden="true">
          <motion.span
            className={`block ${lineClassName}`}
            variants={{
              hidden: { y: "110%" },
              visible: {
                y: "0%",
                transition: {
                  duration,
                  delay: delay + i * stagger,
                  ease: [0.16, 1, 0.3, 1],
                },
              },
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

// Simple fade + rise on scroll into view.
export const FadeIn = ({
  children,
  className = "",
  delay = 0,
  y = 28,
  once = true,
  amount = 0.3,
  ...props
}) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    {...props}
  >
    {children}
  </motion.div>
);
